module.exports = __webpack_public_path__ + "img/8.ec8e9eb4.png";